import { connect } from 'react-redux';
import { uiselector } from '../selector';
import { PriceHider } from '../components/price/index';

import {
  CartPortal,
  NavPortal,
  ArticleDetailPortal,
} from '../components/portals';
import { ResponsiveFilterContainer } from '../components/filter/responsiveFilter';
import {
  toggleCart,
  toggleNav,
  togglePrices,
  toggleArticleDetail,
} from '../actions';

export const Cart = connect(
  state => {
    const { showCart } = uiselector('showCart')(state);
    return {
      showCart,
    };
  },
  dispatch => ({
    toggleCart: () => dispatch(toggleCart()),
  })
)(CartPortal);

export const Nav = connect(
  state => {
    const { showPrices, showNav } = uiselector(['showPrices', 'showNav'])(
      state
    );
    return {
      showPrices,
      showNav,
    };
  },
  dispatch => ({
    toggleNav: () => dispatch(toggleNav()),
    togglePrices: () => dispatch(togglePrices()),
  })
)(NavPortal);

export const ResponsiveFilter = connect(state => {
  const { showFilter } = uiselector('showFilter')(state);
  return {
    showFilter,
  };
})(ResponsiveFilterContainer);

export const ArticleDetail = connect(
  state => {
    const { showDetail, activeItem } = uiselector(['showDetail', 'activeItem'])(
      state
    );
    return {
      showDetail,
      item: activeItem,
    };
  },
  dispatch => ({
    toggleArticleDetail: () => dispatch(toggleArticleDetail()),
  })
)(ArticleDetailPortal);

export const ConnectedPriceHider = connect(
  state => {
    const { showPrices } = uiselector('showPrices')(state);
    return {
      showPrices,
    };
  },
  null
)(PriceHider);



// WEBPACK FOOTER //
// ./src/containers/ui.js